import { DollarOutlined } from "@ant-design/icons";
import { Button, Form, Input, Modal } from "antd";
import { FC, useState } from "react";

interface SendMoneyButtonProps {
  updateEmbedding: (requests: any) => void;
  transactions: {
    submission: { amount: number };
    adhocTransactions: { amount: number; reason: string }[];
  };
  disabled: boolean;
}

export const SendRefundButton: FC<SendMoneyButtonProps> = (props) => {
  const [isOpen, setIsOpen] = useState(false);
  const [form] = Form.useForm();
  const [isAmountValid, setIsAmountValid] = useState(false);

  const openModal = () => {
    setIsOpen(true);
  };

  const closeModal = () => {
    form.resetFields();
    setIsOpen(false);
  };

  const handleConfirm = () => {
    props.updateEmbedding({
      value: "sendRefund",
      message: `Send US$${form.getFieldValue("amount")} Refund`,
      reason: form.getFieldValue("reason"),
      amount: form.getFieldValue("amount"),
      icon: <DollarOutlined />,
    });
    form.resetFields();
    closeModal();
  };

  const handleCancel = () => {
    closeModal();
  };

  const calculateTotalRefund = () => {
    const { submission, adhocTransactions } = props.transactions;
    if (!submission?.amount) {
      return 0;
    }
    const totalAdhocRefunds = adhocTransactions.reduce(
      (total, transaction) => total + transaction?.amount,
      0
    );
    return submission?.amount + totalAdhocRefunds;
  };

  const handleAmountChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    const parsedValue = parseFloat(value);
    const maxRefund = calculateTotalRefund();

    if (!isNaN(parsedValue) && parsedValue >= 0) {
      form.setFieldsValue({ amount: value });
      setIsAmountValid(parsedValue <= maxRefund && parsedValue > 0);
    } else {
      form.setFieldsValue({ amount: "" });
      setIsAmountValid(false);
    }
  };

  return (
    <>
      <Modal
        title="Send Refund"
        footer={null}
        open={isOpen}
        onCancel={handleCancel}
      >
        <Form form={form}>
          <Form.Item
            label="Amount"
            name="amount"
            rules={[
              {
                required: true,
                message: "Please input the amount!",
              },
              {
                validator(_, value) {
                  const maxRefund = calculateTotalRefund();
                    if (value && isNaN(Number(value))) {
                    return Promise.reject(new Error("Amount must be a valid number!"));
                    }
                  if (value && parseFloat(value) == 0) {
                    return Promise.reject(new Error("Amount cannot be zero!"));
                  }
                  if (value && parseFloat(value) > maxRefund) {
                    return Promise.reject(
                      new Error(`Amount cannot exceed US$${maxRefund.toFixed(2)}!`)
                    );
                  }
                  return Promise.resolve();
                },
              },
            ]}
          >
            <Input
              type="number"
              placeholder="Enter Amount"
              style={{ width: "35%" }}
              min={0}
              onChange={handleAmountChange}
            />
          </Form.Item>
          <Form.Item
            label="Reason"
            name="reason"
            rules={[
              {
                required: true,
                message: "Please enter the reason!",
              },
            ]}
          >
            <Input
              type="text"
              placeholder="Enter Reason"
              style={{ width: "100%" }}
            />
          </Form.Item>
          <div style={{ display: "flex", flexDirection: "row-reverse" }}>
            <Button
              type="primary"
              htmlType="submit"
              style={{ marginTop: 10 }}
              onClick={handleConfirm}
              disabled={!isAmountValid}
            >
              Create Request
            </Button>
          </div>
        </Form>
      </Modal>
      <Button
        style={{
          width: "100%",
          borderRadius: "8px",
          marginRight: 10,
          marginBottom: 10,
          marginTop: 10,
        }}
        onClick={openModal}
        disabled={props.disabled}
      >
        <DollarOutlined /> Send Refund
      </Button>
    </>
  );
};
